<button class="show-hide-password-button" type="button" (click)="togglePassword()" *ngrxLet="inputParent$ as inputParent">
    {{ "dtmUi.passwordVisibilitySwitch.label" | transloco : { value: inputParent?.type } }}
</button>
